// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__Ult04","header":"Header_header__co-Il","headerTitle":"Header_headerTitle__m0-hc","headerLogo":"Header_headerLogo__gaa9X"};